import React from 'react';
import { useHistory } from "react-router-dom";
import { Alert } from '@material-ui/lab';
import CustomButton from './CustomButton';

export default function ChangePasswordSuccess() {
  let history = useHistory();

  return <React.Fragment>
    <Alert severity="success" style={{ marginBottom: 16 }}>Votre mot de passe à été changé avec succès</Alert>
    <CustomButton color="secondary" onClick={() => history.push("/sign-up")}>Connecter</CustomButton>
  </React.Fragment>;
}
